/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-22.
 * Singleton store
 * 
 * How to use it 
 * 
 * import Store from '../../store';
 * const store = new Store();
 * 
 * execute dispatch directly from store
 */
import ReduxThunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';

let instance = null;


class Store {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    create(reducers, defaults) {
        instance = createStore(reducers, defaults, applyMiddleware(ReduxThunk));
        return instance;
    }
}

export default Store;



// WEBPACK FOOTER //
// ./store.js